import { getGoogleAuthCbParam, getValuesFromUrl } from './auth';

export const sectionList = {
  activationCodeDetails: 'activation-code',
  accountDetails: 'account-details',
  addressDetails: 'address-details',
  payment: 'payment'
};

export const sectionHeader = {
  activationCodeDetails: {
    label: 'views.subscriptionActivate.activationCodeDetails.sectionHeader.label'
  },
  accountDetails: {
    step: 'views.subscriptionActivate.accountDetails.sectionHeader.step',
    label: 'views.subscriptionActivate.accountDetails.sectionHeader.label',
    actionLabel: 'views.subscriptionActivate.accountDetails.sectionHeader.actionLabel'
  },
  addressDetails: {
    step: 'views.subscriptionActivate.addressDetails.sectionHeader.step',
    label: 'views.subscriptionActivate.addressDetails.sectionHeader.label',
    actionLabel: 'views.subscriptionActivate.addressDetails.sectionHeader.actionLabel'
  },
  payment: {
    step: 'views.subscriptionActivate.payment.sectionHeader.step',
    label: 'views.subscriptionActivate.payment.sectionHeader.label',
    actionLabel: 'views.subscriptionActivate.payment.sectionHeader.actionLabel'
  }
};

export function getActivationCode() {
  let value = '';
  const params = getGoogleAuthCbParam();
  if (params) {
    const { activationCode } = params.userInfo;
    value = activationCode;
  } else {
    const urlValues = getValuesFromUrl(['activation_code']);
    value = urlValues.activation_code;
  }
  return value;
}

export function processSubscriptionActivateUrlOnLogout() {
  const params = getGoogleAuthCbParam();
  const { appHistory, location } = window;
  let redirect = '';
  if (params) {
    const { activationCode } = params.userInfo;
    redirect = `${location.pathname}?activation_code=${activationCode}`;
  } else {
    redirect = `${location.pathname}${location.search}`;
  }

  appHistory.replace(redirect);
  window.location.reload();
}

export function validatePasswordSubscriptionActivate(password = '') {
  if (!password.trim()) {
    return 'libs.subscriptionActivate.message.required';
  } else if (password.length < 8) {
    return 'libs.subscriptionActivate.message.invalidPassword';
  }
  return '';
}



// WEBPACK FOOTER //
// ./src/libs/subscriptionActivate.js